/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')

  .component('changingNumber', {
    template: '<span>{{$ctrl.currentNumber}}</span>',
    bindings: {
      number: '<'
    },
    controller($interval, $scope) {
      this.currentNumber = 0;

      let interval = $interval(() => {
      // Why 7 or 23? They is not so common multipliers in head so it looks
      // more random than say 5 or 10
        if(this.currentNumber - 100 > this.number) {
          this.currentNumber = this.currentNumber - 23;
        } else if(this.currentNumber - 25 > this.number) {
          this.currentNumber = this.currentNumber - 7;
        } else if(this.currentNumber > this.number) {
          this.currentNumber--;
        } else if(this.currentNumber + 100 < this.number) {
          this.currentNumber = this.currentNumber + 23;
        } else if(this.currentNumber + 25 < this.number) {
          this.currentNumber = this.currentNumber + 7;
        } else if(this.currentNumber < this.number) {
          this.currentNumber++;
        }
      }, 30);

      $scope.$on('$destroy', () => {
        $interval.cancel(interval);
      });
    }

  });





// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/changing_number/changing_number.js